export default {"src":"/_next/static/media/TH.6292ace1.svg","height":34,"width":50,"blurWidth":0,"blurHeight":0};